export default __webpack_public_path__ + "static/media/player_leaves.56c08f01.mp3";